import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const Delivery = forwardRef(function Delivery(props, ref) {
  const { color = '#000000', size = 16, ...others } = props;

  return (
    <svg
      fill="none"
      height={size}
      ref={ref}
      viewBox="0 0 13 16"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...others}
    >
      <path
        d="M8.3323 1.3335C5.57512 1.3335 3.33334 3.57527 3.33334 6.33245C3.33334 9.79778 7.84623 14.3526 8.03898 14.5453C8.11859 14.6249 8.22754 14.6668 8.3323 14.6668C8.43705 14.6668 8.546 14.6249 8.62561 14.5453C8.81836 14.3526 13.3312 9.79778 13.3312 6.33245C13.3354 3.57527 11.0937 1.3335 8.3323 1.3335ZM8.3323 8.83402C6.95371 8.83402 5.83072 7.71104 5.83072 6.33245C5.83072 4.95386 6.95371 3.83088 8.3323 3.83088C9.71088 3.83088 10.8339 4.95386 10.8339 6.33245C10.8339 7.71104 9.71088 8.83402 8.3323 8.83402Z"
        fill={color}
      />
    </svg>
  );
});

Delivery.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Delivery;
